import Vue from 'vue'
import helperFunctions from '../helpers/functions'
import router from '../router'

const steps = {
  selectVehicle: {
    id: 'selectVehicle',
    stepNumber: 1,
    title: 'Enter Your Vehicle',
    passedValidation: false,
    stickyNavigationOptions: {
      visible: true,
      buttons: {
        nextButton: {
          text: 'Find Your System',
          buttonClass: 'stickynav-button-full button__solid--blue',
          linkTo: 'selectSystem',
          requireStepValidation: true
        }
      }
    }
  },
  selectSystem: {
    id: 'selectSystem',
    stepNumber: 2,
    title: 'Choose Your System',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  selectCommunication: {
    id: 'selectCommunication',
    stepNumber: 3,
    title: 'Choose Your Communication Type',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  selectRemote: {
    id: 'selectRemote',
    stepNumber: 4,
    title: 'Choose Your Remote',
    passedValidation: false,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  selectUpgrades: {
    id: 'selectUpgrades',
    stepNumber: 5,
    title: 'Add System Upgrades',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: {
        nextButton: {
          text: 'Add Accessories',
          buttonClass: 'stickynav-button-full button__solid--blue',
          linkTo: 'viewSystem',
          requireStepValidation: true
        }
      }
    }
  },
  viewSystem: {
    id: 'viewSystem',
    stepNumber: 6,
    title: 'Your System is Complete',
    passedValidation: false,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  contactDealer: {
    id: 'contactDealer',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: {
        backButton: {
          text: 'Return to System',
          buttonClass: 'stickynav-button-full button__outline--grey',
          linkTo: 'viewSystem',
          requireStepValidation: false
        }
      }
    }
  }
}

const store = {
  debug: true,
  state: {
    remoteStart: true,
    security: false,
    remoteStartSecurity: false,
    vehicleObject: {
      year: 'Vehicle Year'
    },
    customFields: {},
    dataFromExternal: false,
    selectedMake: 'Vehicle Make',
    selectedModel: 'Vehicle Model',
    selectedYear: 'Vehicle Year',
    selectedYearValue: 'Vehicle Year',
    vehicleMakesData: [],
    vehicleModelsData: [],
    vehicleYearsData: [],
    VehicleManualYearsData: [],
    remotes: null,
    filteredRemotes: null,
    accessories: null,
    steps: steps,
    progressBarSteps: 1,
    selectableOptions: [
      {
        id: 0,
        name: 'Smartphone Control',
        selected: false,
        locked: false,
        lockedMessage: '',
        productId: 240
      },
      {
        id: 1,
        name: 'GPS Tracking',
        selected: false,
        locked: false,
        lockedMessage: '',
        productId: 240
      },
      {
        id: 2,
        name: 'Keyless Touch Entry',
        selected: false,
        locked: false,
        lockedMessage: '',
        productId: 237
      },
      {
        id: 3,
        name: 'ALARMIT KIT',
        selected: false,
        locked: false,
        lockedMessage: 'Since you want to remote start and secure your car, we have added the Alarm It kit for you. This will add the ability to secure your car.',
        productId: 228
      }
    ],
    selectedUpgrades: [],
    selectedRemote: {},
    selectedSystem: {},
    selectedSystemCategory: '',
    selectedCommunication: '',
    selectedRemoteId: 0,
    customerDetails: {
      customerName: '',
      customerEmail: '',
      customerZip: '',
      customerPhone: ''
    },
    formPassedValidation: false,
    currentStep: steps.selectVehicle,
    currentRoute: '',
    selectedDealer: {},
    vehicleJson: null,
    dealers: null,
    dealerLatLon: {},
    systemString: '',
    systems: {},
    showNav: true,
    showVehicleContinueButton: true,
    showMainNav: true,
    inquiryDataSaved: false,
    numberQuotesRequested: 0,
    inquiryId: null,
    showProDealers: false
  },
  holdVehicleJson (responseData) {
    this.state.vehicleJson = responseData
  },
  updateNumberQuotesRequested () {
    this.state.numberQuotesRequested = this.state.numberQuotesRequested + 1
    this.numberQuotesRequestedToState()
  },
  updatePhoneNumber (phoneNumber) {
    this.state.customerDetails.customerPhone = phoneNumber
  },
  numberQuotesRequestedToState () {
    // Save requests made to local storage
    Vue.ls.set('requestsMade', this.state.numberQuotesRequested, 60 * 60 * 1000)
  },
  getRequestNumberFromStorage () {
    // Get number of requests made from local storage
    var requestsFromStorage = parseInt(Vue.ls.get('requestsMade'))

    if (requestsFromStorage) {
      this.state.numberQuotesRequested = requestsFromStorage
    } else {
      this.state.numberQuotesRequested = 0
    }
  },
  changeFormValidationState (bool) {
    this.state.formPassedValidation = bool
    Vue.ls.set('formValidation', bool, 60 * 60 * 1000)
  },
  toggleVehicleContinueButton (bool) {
    this.state.showVehicleContinueButton = bool
  },
  updateVehicleObject (vehicleMake, vehicleModel, vehicleYearId) {
    var makeValue = vehicleMake
    var modelValue = vehicleModel
    var yearId = vehicleYearId
    var selectedVehicle = {}

    var vehicleMakes = this.state.vehicleJson.makes[0]

    for (var i in vehicleMakes) {
      if (i === makeValue) {
        vehicleMake = vehicleMakes[i]
        for (var x in vehicleMake) {
          if (vehicleMakes[i][x].id.toString() === yearId) {
            selectedVehicle = vehicleMakes[i][x]
          }
        }
      }
    }

    this.state.vehicleObject = selectedVehicle
    this.state.vehicleObject.make = makeValue
    this.state.vehicleObject.model = modelValue

    this.state.selectedMake = makeValue
    this.state.selectedModel = modelValue
    this.state.selectedYearValue = selectedVehicle.year

    // Set vehicle local storage
    var currentStateToString = JSON.stringify(this.state.vehicleObject)
    Vue.ls.set('vehicle', currentStateToString, 60 * 60 * 1000)
    Vue.ls.set('selectedMake', this.state.selectedMake, 60 * 60 * 1000)
    Vue.ls.set('selectedModel', this.state.selectedModel, 60 * 60 * 1000)
    Vue.ls.set('selectedYear', this.state.selectedYear, 60 * 60 * 1000)
    Vue.ls.set('selectedYearValue', selectedVehicle.year, 60 * 60 * 1000)
  },
  updateCurrentStateRoute (currentRoute) {
    this.state.currentRoute = currentRoute
    this.state.currentStep = this.state.steps[currentRoute]

    // Save current step and steps local storage
    this.setStepsLocalStorage()
  },
  toggleMainNav () {
    if (this.state.showMainNav) {
      this.state.showMainNav = false
    } else {
      this.state.showMainNav = true
    }
  },
  updateCurrentStep (newValue) {
    this.state.currentStep = newValue
  },
  holdRemotes (responseObj) {
    this.state.remotes = responseObj
    // Stores remotes in local storage to halt additional ajax call for remotes
    var remotesString = JSON.stringify(responseObj)

    // change loadingRemotes on state object to j

    Vue.ls.set('remotes', remotesString, 60 * 60 * 1000)
  },
  holdSystems (responseObj) {
    this.state.systems = responseObj
    // Stores systems in local storage to halt additional ajax call for systems
    var systemsString = JSON.stringify(responseObj)

    Vue.ls.set('systems', systemsString, 60 * 60 * 1000)
  },
  holdAccessories (responseObj) {
    this.state.accessories = responseObj
    // Store systems in local storage
    var accessoriesString = JSON.stringify(responseObj)
    Vue.ls.set('accessories', accessoriesString, 60 * 60 * 1000)
  },
  holdCustomFields (responseObj) {
    this.state.customFields = responseObj

    // Store custom fields in local storage
    var customFieldsString = JSON.stringify(responseObj)
    Vue.ls.set('customFields', customFieldsString, 60 * 60 * 1000)
  },
  removeOptionLocks () {
    for (var option in this.state.selectableOptions) {
      this.state.selectableOptions[option].locked = false
    }
  },
  holdSelectedSystem (str) {
    this.state.selectedSystemCategory = str

    if (str === 'MAX IT') {
      this.state.remoteStartSecurity = true
      this.state.remoteStart = false
      this.state.security = false
    } else if (str === 'START IT') {
      this.state.remoteStartSecurity = false
      this.state.remoteStart = true
      this.state.security = false
    } else if (str === 'ALARM IT') {
      this.state.remoteStartSecurity = false
      this.state.remoteStart = false
      this.state.security = true
    }

    if (!helperFunctions.isEmpty(this.state.selectedRemote)) {
      this.updateSelectedSystem()
    }

    Vue.ls.set('selectedSystemCategory', str, 60 * 60 * 1000)

    // Save steps to local storage
    this.setStepsLocalStorage()
    this.setLocalStorageSystem()
  },
  setSelectedCommunication (str) {
    this.state.selectedCommunication = str

    this.filterRemoteList()

    // Save communication type and filtered remotes to local storage
    Vue.ls.set('communicationType', str, 60 * 60 * 1000)

    // Save steps to local storage
    this.setStepsLocalStorage()
  },
  setCategorySelectionState (category) {
    switch (category) {
      case 'remoteStart':
        this.state.security = false
        this.state.remoteStart = true
        this.state.remoteStartSecurity = false

        // Loop through each selectableOption and remove locks
        this.removeOptionLocks()

        break
      case 'security':
        this.state.security = true
        this.state.remoteStart = false
        this.state.remoteStartSecurity = false

        // Loop through each selectableOption and remove locks
        this.removeOptionLocks()

        break
      case 'remoteStartSecurity':
        this.state.security = false
        this.state.remoteStart = false
        this.state.remoteStartSecurity = true

        // Check if vehicle specific ID
        // change to remote start and add ALARMIT KIT kit
        if (this.state.vehicleObject.vehicleSpecificId) {
          for (var option in this.state.selectableOptions) {
            if (this.state.selectableOptions[option].name === 'ALARMIT KIT') {
              this.updateSelectedAttribute(this.state.selectableOptions[option].id)
            }
          }
        }

        break
      default:
    }
  },
  updateSelectedAttribute (upgradeId) {
    // Loop through attributes to find matching object
    for (var upgrade in this.state.accessories) {
      if (this.state.accessories[upgrade].ID === upgradeId) {
        var duplicateInArray = false
        var upgradeIndex

        // Set selected status
        if (this.state.accessories[upgrade].selected) {
          this.state.accessories[upgrade].selected = false

          // Remove attribute from selectedUpgrades
          // upgradeIndex = this.state.selectedUpgrades.indexOf(this.state.accessories[upgrade])

          var filteredSelectedUpgrades = this.state.selectedUpgrades.filter(function (el) {
            return el.ID !== upgradeId
          })

          this.state.selectedUpgrades = filteredSelectedUpgrades

          // if (upgradeIndex > -1) {
          //   this.state.selectedUpgrades.splice(upgradeIndex, 1)
          // }
        } else {
          this.state.accessories[upgrade].selected = true

          // Add upgrade to selectedUpgrades
          // Check if upgradeId already exists before pushing a duplicate
          for (var selectedUpgrades in this.state.selectedUpgrades) {
            if (this.state.selectedUpgrades[selectedUpgrades].ID === upgradeId) {
              duplicateInArray = true
            }
          }

          if (duplicateInArray === false) {
            // Push upgrade onto array
            this.state.selectedUpgrades.push(this.state.accessories[upgrade])
          } else {
            upgradeIndex = this.state.selectedUpgrades.indexOf(this.state.accessories[upgrade])

            this.state.selectedUpgrades.splice(upgradeIndex, 1)
          }
        }

        this.setOptionsLocalStorage()
      }
    }
  },
  updateSelectedRemoteId (remoteId) {
    this.state.selectedRemoteId = remoteId

    if (remoteId !== 0) {
      // Loop through remotes to find matching ID
      for (var currentRemote in this.state.remotes) {
        if (this.state.remotes[currentRemote].ID === remoteId) {
          this.updateSelectedRemoteObj(JSON.parse(JSON.stringify(this.state.remotes[currentRemote])))

          // If PRO remote add flag to be able to filter dealer list to PRO only
          if (this.state.remotes[currentRemote].post_title.indexOf('PRO') !== -1) {
            this.state.showProDealers = true
            Vue.ls.set('showProDealers', true, 60 * 60 * 1000)
          } else {
            Vue.ls.set('showProDealers', false, 60 * 60 * 1000)
          }
        }
      }
    } else {
      this.updateSelectedRemoteObj(0)
    }
  },
  updateSelectedRemoteObj (obj) {
    this.state.selectedRemote = obj

    this.state.steps['selectRemote'].passedValidation = true

    // Update local storage
    this.setLocalStorageRemote()

    // Save steps to local storage
    this.setStepsLocalStorage()
  },
  updateSelectedSystem () {
    // Determine the correct system based on remote, system category, and vehicle make
    var currentCompatibleSystems = JSON.parse(JSON.stringify(this.state.systems))
    var currentVehicleSpecificId = this.state.vehicleObject.vehicleSpecificId
    var currentVehicleMake = this.state.vehicleObject.make

    // Check vehicle object for vehicle specific id, then check if remote is compatible with that system
    // If remote is not compatible with that system, return a universal system
    if (currentVehicleSpecificId !== '') {
      // If selected category is security, ignore vehicle specific system and assign alarm it
      if (this.state.security === true) {
        // Search compatible systems for alarm it system
        for (var currentSystem in currentCompatibleSystems) {
          if (currentCompatibleSystems[currentSystem].model_number === 'FT-7300A-CONT') {
            // Assign current system as selectedSystem
            this.state.selectedSystem = currentCompatibleSystems[currentSystem]
            this.setOptionsLocalStorage()
            return
          }
        }

        // If loop does not return value default to first system
        this.state.selectedSystem = currentCompatibleSystems[0]
        this.setOptionsLocalStorage()
        return
      } else {
        for (var system in currentCompatibleSystems) {
          if (currentCompatibleSystems[system].harness_model_numbers) {
            // Get all compatible makes
            var allCompatibleMakes = currentCompatibleSystems[system].compatible_makes
            var isMakeCompatible = false
            // Check all compatible makes for selected make
            for (var compatibleMake in allCompatibleMakes) {
              if (allCompatibleMakes[compatibleMake] === currentVehicleMake) {
                isMakeCompatible = true
              }
            }

            var lengthOfHarnesses = helperFunctions.objectLength(currentCompatibleSystems[system].harness_model_numbers)
            var loopCounter = 0

            // Loop through harness_model_numbers and check for a matching vehicleSpecificID
            for (var tHarnessId in currentCompatibleSystems[system].harness_model_numbers) {
              if (currentCompatibleSystems[system].harness_model_numbers[tHarnessId].model_number === currentVehicleSpecificId && isMakeCompatible) {
                // Assign current system as selectedSystem
                this.state.selectedSystem = currentCompatibleSystems[system]
                this.setLocalStorageSystem()
                // Check if remote start and security category option
                // If so change to remote start and add ALARMIT KIT kit
                if (this.state.remoteStartSecurity) {
                  for (var option in this.state.selectableOptions) {
                    if (this.state.selectableOptions[option].name === 'FT-7300A-CONT') {
                      this.updateSelectedAttribute(this.state.selectableOptions[option].productId)
                      this.setOptionsLocalStorage()
                      this.setLocalStorageSystem()
                    }
                  }
                }
                return
              }

              loopCounter += 1

              // If reach the end of the loop and no results, set as default system
              if (loopCounter === lengthOfHarnesses + 1) {
                this.state.selectedSystem = currentCompatibleSystems[0]
                this.setLocalStorageSystem()
                return
              }
            }
          }
        }
      }
      this.setLocalStorageSystem()
    } else if (this.state.remoteStart === 'true' || this.state.remoteStart === true) {
      for (var theSystem in currentCompatibleSystems) {
        if (currentCompatibleSystems[theSystem].model_number === 'FT-7200S-CONT') {
          // Assign current system as selectedSystem
          this.state.selectedSystem = currentCompatibleSystems[theSystem]
          this.setLocalStorageSystem()
          return
        }
      }
      // If loop does not return value default to first system
      this.state.selectedSystem = currentCompatibleSystems[0]
      this.setLocalStorageSystem()
      return
    } else if (this.state.security === 'true' || this.state.security === true) {
      for (theSystem in currentCompatibleSystems) {
        if (currentCompatibleSystems[theSystem].model_number === 'FT-7300A-CONT') {
          // Assign current system as selectedSystem
          this.state.selectedSystem = currentCompatibleSystems[theSystem]
          this.setLocalStorageSystem()
          return
        }
      }
      // If loop does not return value default to first system
      this.state.selectedSystem = currentCompatibleSystems[0]
      this.setLocalStorageSystem()
      return
    } else if (this.state.remoteStartSecurity === 'true' || this.state.remoteStartSecurity === true) {
      for (theSystem in currentCompatibleSystems) {
        if (currentCompatibleSystems[theSystem].model_number === 'FT-7000AS-CONT') {
          // Assign current system as selectedSystem
          this.state.selectedSystem = currentCompatibleSystems[theSystem]
          this.setLocalStorageSystem()
          return
        }
      }
      // If loop does not return value default to first system
      this.state.selectedSystem = currentCompatibleSystems[0]
      this.setLocalStorageSystem()
      return
    } else {
      this.state.selectedSystem = currentCompatibleSystems[0]
      this.setLocalStorageSystem()
      return
    }
  },
  filterRemoteList () {
    var filteredRemotesList = []
    var currentRemotes = JSON.parse(JSON.stringify(this.state.remotes))

    // Loop through remotes and check if remote is compatible with selected system
    for (var currentRemote in currentRemotes) {
      // Filter based on compatible system
      for (var compatibleSystem in currentRemotes[currentRemote].compatible_systems) {
        if (currentRemotes[currentRemote].compatible_systems[compatibleSystem].ID === this.state.selectedSystem.ID) {
          // Now check if communication matches
          for (var currentTerm in currentRemotes[currentRemote].terms) {
            if (currentRemotes[currentRemote].terms[currentTerm].slug === this.state.selectedCommunication) {
              // If both match, push to filtered list
              filteredRemotesList.push(currentRemotes[currentRemote])
            }
          }
        }
      }
    }

    // Convert the array to an object
    filteredRemotesList = filteredRemotesList.reduce(function (result, item, index, array) {
      result[index] = item
      return result
    }, {})

    // Update the state with filtered remotes
    this.state.filteredRemotes = filteredRemotesList

    // Filtered remote list to local storage
    var filteredRemotesString = JSON.stringify(filteredRemotesList)
    Vue.ls.set('filteredRemotes', filteredRemotesString, 60 * 60 * 1000)
  },
  updateSystemStringState (str) {
    this.state.systemString = str

    Vue.ls.set('systemstring', str, 60 * 60 * 1000)
  },
  updateDealersState (obj) {
    this.state.dealers = obj
    // Set local storage after dealers retrieved
    store.setInquiryDataLocalStorage()
  },
  updateMapState (str) {
    this.state.mapString = str
  },
  updateCurrentStepValidation (bool) {
    var currentStepKey = this.state.currentStep.id
    this.state.currentStep.passedValidation = bool
    this.state.steps[currentStepKey].passedValidation = bool

    this.setStepsLocalStorage()
  },
  setStepsLocalStorage () {
    var stepsString = JSON.stringify(this.state.steps)
    Vue.ls.set('steps', stepsString, 60 * 60 * 1000)

    var currentStepString = JSON.stringify(this.state.currentStep)
    Vue.ls.set('currentStep', currentStepString, 60 * 60 * 1000)
  },
  getStepsLocalStorage () {
    var stepsString = Vue.ls.get('steps', '')
    var stateStepsString = JSON.stringify(this.state.steps)

    if (stepsString !== '' && stateStepsString !== stepsString) {
      var stepsObj = JSON.parse(stepsString)
      this.state.steps = stepsObj

      // Set current step from local storage
      var currentStepString = Vue.ls.get('currentStep', stepsObj[0])
      this.state.currentStep = JSON.parse(currentStepString)
    }
  },
  checkLocalStorageRemotes () {
    var localStorageRemotes = Vue.ls.get('remotes', '')
    if (localStorageRemotes !== '') {
      var localStorageRemotesObj = JSON.parse(Vue.ls.get('remotes'))
      this.state.remotes = localStorageRemotesObj
    }
  },
  setLocalStorageRemote () {
    if (this.state.steps.selectRemote.passedValidation) {
      var currentRemoteString = JSON.stringify(this.state.selectedRemote)
      Vue.ls.set('selectedRemote', currentRemoteString, 60 * 60 * 1000)
      Vue.ls.set('remoteID', this.state.selectedRemoteId, 60 * 60 * 1000)

      this.setStepsLocalStorage()
    }
  },
  setLocalStorageSystem () {
    var currentSystemString = JSON.stringify(this.state.selectedSystem)
    Vue.ls.set('selectedSystem', currentSystemString, 60 * 60 * 1000)
  },
  setOptionsLocalStorage () {
    // Set options data
    var selectableOptionsString = JSON.stringify(this.state.selectableOptions)
    Vue.ls.set('selectableOptions', selectableOptionsString, 60 * 60 * 1000)

    // Set selectedUpgrades data
    var selectedUpgradesString = JSON.stringify(this.state.selectedUpgrades)
    Vue.ls.set('selectedUpgrades', selectedUpgradesString, 60 * 60 * 1000)

    // Set accessories data
    var accessoriesString = JSON.stringify(this.state.accessories)
    Vue.ls.set('accessories', accessoriesString, 60 * 60 * 1000)
  },
  setInquiryDataLocalStorage () {
    // Store inquiry info
    var customerInfoString = JSON.stringify(this.state.customerDetails)
    Vue.ls.set('customerDetails', customerInfoString, 60 * 60 * 1000)
    // Store dealer list
    var dealerListString = JSON.stringify(this.state.dealers)
    Vue.ls.set('dealers', dealerListString, 60 * 60 * 1000)
    // Steps to local storage
    this.setStepsLocalStorage()
  },
  inquiryDataSaved (inquiryId) {
    this.state.inquiryDataSaved = true
    this.state.inquiryId = inquiryId

    // Store inquiry id in local storage
    Vue.ls.set('inquiryId', inquiryId, 60 * 60 * 1000)
  },
  updateManualYears (arr) {
    this.state.VehicleManualYearsData = arr
  },
  getStateObj () {
    var cleanedSelectedRemote = JSON.parse(JSON.stringify(this.state.selectedRemote))
    cleanedSelectedRemote.compatible_systems = false

    var cleanedSelectedSystem = JSON.parse(JSON.stringify(this.state.selectedSystem))
    cleanedSelectedSystem.compatible_systems = false

    var currentStateData = {
      remoteStart: this.state.remoteStart,
      security: this.state.security,
      remoteStartSecurity: this.state.remoteStartSecurity,
      vehicleObject: this.state.vehicleObject,
      customFields: this.state.customFields,
      selectedMake: this.state.selectedMake,
      selectedModel: this.state.selectedModel,
      selectedYear: this.state.selectedYear,
      selectedYearValue: this.state.selectedYearValue,
      selectedUpgrades: this.state.selectedUpgrades,
      selectedRemote: cleanedSelectedRemote,
      selectedSystem: cleanedSelectedSystem,
      selectedSystemCategory: this.state.selectedSystemCategory,
      selectedCommunication: this.state.selectedCommunication,
      selectedRemoteId: this.state.selectedRemoteId,
      currentStep: this.state.currentStep,
      currentRoute: this.state.currentRoute,
      systemString: this.state.systemString,
      showNav: true,
      inquiryDataSaved: true,
      inquiryId: this.state.inquiryId
    }
    return currentStateData
  },
  updateStateWithData (obj) {
    if (obj.remoteStart === 'true') {
      this.state.remoteStart = true
    } else {
      this.state.remoteStart = false
    }

    if (obj.security === 'true') {
      this.state.security = true
    } else {
      this.state.security = false
    }

    if (obj.remoteStartSecurity === 'true') {
      this.state.remoteStartSecurity = true
    } else {
      this.state.remoteStartSecurity = false
    }

    this.state.vehicleObject = obj.vehicleObject
    this.state.customFields = obj.customFields
    this.state.selectedMake = obj.selectedMake
    this.state.selectedModel = obj.selectedModel
    this.state.selectedYear = obj.selectedYear
    this.state.selectedYearValue = obj.selectedYearValue
    this.state.selectedUpgrades = obj.selectedUpgrades
    this.state.selectedRemote = obj.selectedRemote
    this.state.selectedSystem = obj.selectedSystem
    this.state.selectedSystemCategory = obj.selectedSystemCategory
    this.state.selectedCommunication = obj.selectedCommunication
    this.state.selectedRemoteId = obj.selectedRemoteId
    this.state.formPassedValidation = false
    this.state.currentStep = obj.currentStep
    this.state.currentRoute = obj.currentRoute
    this.state.systemString = obj.systemString

    if (obj.inquiryDataSaved === 'true') {
      this.state.inquiryDataSaved = true
    } else {
      this.state.inquiryDataSaved = false
    }

    this.state.inquiryId = obj.inquiryId
  },
  getStoreDataToSave () {
    // Package up necessary data
    var data = {
      remoteStart: this.state.remoteStart,
      security: this.state.security,
      remoteStartSecurity: this.state.remoteStartSecurity,
      selectedRemoteId: this.state.selectedRemote.ID,
      selectedRemoteName: this.state.selectedRemote.post_title,
      selectedVehicle: this.state.vehicleObject,
      selectedUpgrades: this.state.selectedUpgrades,
      customerEmail: this.state.customerDetails.customerEmail,
      customerName: this.state.customerDetails.customerName,
      customerPhone: this.state.customerDetails.customerPhone,
      customerZip: this.state.customerDetails.customerZip,
      systemName: this.state.systemString,
      systemId: this.state.selectedSystem.ID
    }

    // Return obj
    return data
  },
  clearLocalStorage () {
    Vue.ls.clear()
  },
  getLocalStorage () {
    // Get Steps
    this.getStepsLocalStorage()

    // Get vehicle object
    var vehicleObject = JSON.parse(Vue.ls.get('vehicle', '{}'))

    if (!helperFunctions.isEmpty(vehicleObject)) {
      this.state.vehicleObject = vehicleObject
    }
    this.state.selectedMake = Vue.ls.get('selectedMake', 'Vehicle Make')
    this.state.selectedModel = Vue.ls.get('selectedModel', 'Vehicle Model')
    this.state.selectedYear = Vue.ls.get('selectedYear', 'Vehicle year')
    this.state.selectedYearValue = Vue.ls.get('selectedYearValue', 'Vehicle Year')
    this.state.dataFromExternal = Vue.ls.get('dataSent', false)

    // Get selected category
    this.state.selectedSystemCategory = Vue.ls.get('selectedSystemCategory')

    // Get communication type and filtered remotes
    var communicationTypeString = Vue.ls.get('communicationType')
    var filteredRemotesObject = JSON.parse(Vue.ls.get('filteredRemotes'))

    if (communicationTypeString !== '') {
      this.state.selectedCommunication = communicationTypeString
      this.state.filteredRemotes = filteredRemotesObject
    }

    // Get selected remote
    var remoteIdLocalStorage = Vue.ls.get('remoteID')
    if (remoteIdLocalStorage) {
      this.state.selectedRemote = JSON.parse(Vue.ls.get('selectedRemote'))
      this.state.selectedRemoteId = remoteIdLocalStorage

      // Get Selected system
      this.state.selectedSystem = JSON.parse(Vue.ls.get('selectedSystem'))
      this.state.systemString = Vue.ls.get('systemstring')

      // Get PRO status
      this.state.showProDealers = Vue.ls.get('showProDealers')
    }

    // Get remotes
    var localStorageRemotes = Vue.ls.get('remotes', '')
    if (localStorageRemotes !== '') {
      var localStorageRemotesObj = JSON.parse(Vue.ls.get('remotes'))
      this.state.remotes = localStorageRemotesObj

      // Get accessories
      var localStorageAccessoryObj = JSON.parse(Vue.ls.get('accessories'))
      this.state.accessories = localStorageAccessoryObj

      // Get custom fields
      var customFieldsObject = JSON.parse(Vue.ls.get('customFields'))
      this.state.customFields = customFieldsObject

      var localStorageRemoteFeatures = Vue.ls.get('remoteFeatures')
      if (localStorageRemoteFeatures !== '') {
        // Get remote features
        var remoteFeaturesArray = JSON.parse(Vue.ls.get('remoteFeatures'))
        this.state.remoteFeatures = remoteFeaturesArray
      }
    }

    // Get contact details
    var customerDetailsObject = JSON.parse(Vue.ls.get('customerDetails'))
    var dealerListObject = JSON.parse(Vue.ls.get('dealers'))
    this.state.inquiryId = JSON.parse(Vue.ls.get('inquiryId'))

    this.state.formPassedValidation = Vue.ls.get('formValidation', false)

    if (dealerListObject && customerDetailsObject) {
      this.state.customerDetails = customerDetailsObject
      this.state.dealers = dealerListObject
    }
  },
  resetBuilder () {
    // Reset values on state
    this.state.selectedMake = 'Vehicle Make'
    this.state.selectedModel = 'Vehicle Model'
    this.state.selectedYear = 'Vehicle year'
    this.state.selectedYearValue = 'Vehicle year'
    this.state.selectedRemote = {}
    this.state.selectedRemoteId = 0
    this.state.selectedSystem = {}
    this.state.selectedSystemCategory = ''
    this.state.remoteStart = false
    this.state.remoteStartSecurity = false
    this.state.security = false
    this.state.steps = steps
    this.state.selectedUpgrades = []
    this.state.systemString = ''
    this.state.vehicleObject.year = 'Vehicle Year'
    this.state.customerDetails.customerEmail = ''
    this.state.customerDetails.customerName = ''
    this.state.customerDetails.customerZip = ''
    this.state.customerDetails.customerPhone = ''
    this.state.formPassedValidation = false
    this.state.inquiryDataSaved = false
    this.state.numberQuotesRequested = 0
    this.state.inquiryId = null
    this.state.vehicleObject = { year: 'Vehicle Year' }
    this.state.vehicleModelsData = []
    this.state.vehicleYearsData = []

    // Make sure validation is correct on steps
    this.state.steps.selectVehicle.passedValidation = false
    this.state.steps.selectRemote.passedValidation = false

    // Get accessories from local storage and mutate
    // Loop through accessories and set status to unselected
    var localStorageAccessoryObj = JSON.parse(Vue.ls.get('accessories'))

    for (var currentAccessory in localStorageAccessoryObj) {
      localStorageAccessoryObj[currentAccessory].selected = false
    }

    // Put cleaned accessories back into local state
    var localStorageAccessoryString = JSON.stringify(localStorageAccessoryObj)
    Vue.ls.set('accessories', localStorageAccessoryString, 60 * 60 * 1000)

    // reset values on local storage
    Vue.ls.remove('communicationType')
    Vue.ls.remove('filteredRemotes')
    Vue.ls.remove('remoteID')
    Vue.ls.remove('selectedMake')
    Vue.ls.remove('selectedModel')
    Vue.ls.remove('selectedRemote')
    Vue.ls.remove('selectedSystem')
    Vue.ls.remove('selectedSystemCategory')
    Vue.ls.remove('selectedUpgrades')
    Vue.ls.remove('selectedYear')
    Vue.ls.remove('selectedYearValue')
    Vue.ls.remove('steps')
    Vue.ls.remove('currentStep')
    Vue.ls.remove('vehicle')
    Vue.ls.remove('systemstring')
    Vue.ls.remove('requestsMade')
    Vue.ls.remove('customerDetails')
    Vue.ls.remove('dealers')
    Vue.ls.remove('formValidation')
    Vue.ls.remove('inquiryId')

    // Change route to select vehicle
    store.updateCurrentStateRoute('selectVehicle')
    router.push({ name: 'selectVehicle' })
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js